import '~/assets/scss/personal-funds.scss'

window.addEventListener(`DOMContentLoaded`, () => {
  document.querySelectorAll('.js-scroll-button').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('data-href')).scrollIntoView({ block: "center", behavior: "smooth" });
    });
  });
})